(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('LotSmartWeightUpdateModalController',LotSmartWeightUpdateModalController);

    LotSmartWeightUpdateModalController.$inject = ['$scope','$q','$stateParams','$uibModalInstance','lotList','Lot'];

    function LotSmartWeightUpdateModalController($scope, $q, $stateParams, $uibModalInstance, lotList, Lot) {
        var vm = this;

        vm.lots = lotList;
        vm.isSaving = false;
        vm.save = save;
        vm.clear = clear;
        vm.applyUnitType = applyUnitType;
        vm.updateLotWeights = updateLotWeights;

        vm.combinedWeight = {
            unitType: "KG",
            gw: 0,
            nw: 0,
            tw: 0,
            qty: 0,
            avgGw: 0,
            avgNw: 0,
            avgTw: 0,
            avgGwDisplay: 0,
            avgNwDisplay: 0,
            avgTwDisplay: 0
        };

        getInitialValues();

        function getInitialValues() {
            for(var x = 0; x < vm.lots.length; x++) {
                vm.combinedWeight.qty += vm.lots[x].qtyBales;
                vm.combinedWeight.gw += returnCorrectValue(vm.combinedWeight.unitType, "GW", vm.lots[x]);
                vm.combinedWeight.nw += returnCorrectValue(vm.combinedWeight.unitType, "NW", vm.lots[x]);
            }
            updateLotWeights();
        }

        function computeCombinedWeightValues() {
            vm.combinedWeight.tw = vm.combinedWeight.gw - vm.combinedWeight.nw;
            vm.combinedWeight.avgGw = vm.combinedWeight.gw / vm.combinedWeight.qty;
            vm.combinedWeight.avgNw = vm.combinedWeight.nw / vm.combinedWeight.qty;
            vm.combinedWeight.avgTw = vm.combinedWeight.tw / vm.combinedWeight.qty;
            vm.combinedWeight.avgGwDisplay = Math.round((vm.combinedWeight.avgGw) * 10000000 ) / 10000000;
            vm.combinedWeight.avgNwDisplay = Math.round((vm.combinedWeight.avgNw) * 10000000 ) / 10000000;
            vm.combinedWeight.avgTwDisplay = Math.round((vm.combinedWeight.avgTw) * 10000000 ) / 10000000;
        }

        function updateLotWeights() {
            computeCombinedWeightValues();
            for(var x = 0; x < vm.lots.length; x++) {
                vm.lots[x].purchWtType = vm.combinedWeight.unitType;
                resolveWeightData(Math.round((vm.combinedWeight.avgGw * vm.lots[x].qtyBales) * 10) / 10,
                    Math.round((vm.combinedWeight.avgNw * vm.lots[x].qtyBales) * 10) / 10,
                    Math.round((vm.combinedWeight.avgTw * vm.lots[x].qtyBales) * 10) / 10,
                    vm.lots[x]);
                vm.lots[x].actualWtGrossAvg = vm.combinedWeight.avgGw;
                vm.lots[x].actualWtAvg = vm.combinedWeight.avgNw;
                vm.lots[x].actualWtTareAvg = vm.combinedWeight.avgTw;
                vm.lots[x].landedWtAvg = vm.combinedWeight.avgNw;
                vm.lots[x].landedWtGrossAvg = vm.combinedWeight.avgGw;
                vm.lots[x].landedWtTareAvg = vm.combinedWeight.avgTw;
            }
        }

        function resolveWeightData(gw, nw, tw, lot) {
            switch(lot.purchWtType) {
                case 'KG':
                    lot.purchGrossKgs = gw;
                    lot.purchNetKgs = nw;
                    lot.purchTareKgs = tw;
                    lot.purchLandedGrossKgs = gw;
                    lot.purchLandedNetKgs = nw;
                    lot.purchLandedTareKgs = tw;
                    lot.lotWeightKgs = nw;
                    break;
                case 'LB':
                    lot.purchGrossLbs = gw;
                    lot.purchNetLbs = nw;
                    lot.purchTareLbs = tw;
                    lot.purchLandedGrossLbs = gw;
                    lot.purchLandedNetLbs = nw;
                    lot.purchLandedTareLbs = tw;
                    lot.lotWeightLbs = nw;
                    break;
                case 'MT':
                    lot.purchGrossMTs = gw;
                    lot.purchNetMTs = nw;
                    lot.purchTareMTs = tw;
                    lot.purchLandedGrossMTs = gw;
                    lot.purchLandedNetMTs = nw;
                    lot.purchLandedTareMTs = tw;
                    lot.lotWeightMts = nw;
                    break;
            }
            lot.lotWeightDisplay = nw + " " + lot.purchWtType;
        }

        function applyUnitType() {
            updateLotWeights();
        }

        function returnCorrectValue(unit, which, lot) {
            switch(unit) {
                case 'KG':
                    switch(which) {
                        case 'GW':
                            return lot.purchLandedGrossKgs;
                        case 'NW':
                            return lot.purchLandedNetKgs;
                        case 'TW':
                            return lot.purchLandedTareKgs;
                    }
                case 'LB':
                    switch(which) {
                        case 'GW':
                            return lot.purchLandedGrossLbs;
                        case 'NW':
                            return lot.purchLandedNetLbs;
                        case 'TW':
                            return lot.purchLandedTareLbs;
                    }
                case 'MT':
                    switch(which) {
                        case 'GW':
                            return lot.purchLandedGrossMTs;
                        case 'NW':
                            return lot.purchLandedNetMTs;
                        case 'TW':
                            return lot.purchLandedTareMTs;
                    }
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            var promList = [];
            angular.forEach(vm.lots, function(value) {
                promList.push(Lot.update(value).$promise);
            });
            $q.all(promList).then(function() {
                vm.isSaving = false;
                $uibModalInstance.close();
            });
        }
    }
})();
